import AppInfo from './AppInfo';

export default AppInfo;
